import {BUSCAR_PEDIDOS, ALTERAR_DETALHAMENTO_PEDIDO, BUSCAR_PEDIDOS_ITINEARIO} from '../../actions/types'

const initial = {
  pedidos: [],
  pedidosItinerario: []
};

export default function reducerBuscarPedido (state = initial, action) {
  switch (action.type) {
    case BUSCAR_PEDIDOS: {
      if (action.payload.pedidos) {
        const pedidos = action.payload.pedidos.pedidos.map(pedido => Object.assign({}, pedido, { exibirDetalhe: false }));
        return {
          ...state,
          pedidos,
          total: action.payload.pedidos.total
        }
      }
      return state
    }

    case BUSCAR_PEDIDOS_ITINEARIO: {
      if (action.payload) {
        return {
          ...state,
          pedidosItinerario: action.payload
        }
      }
      return state
    }

    case ALTERAR_DETALHAMENTO_PEDIDO: {
      const pedido = action.payload;
      const indice = state.pedidos.indexOf(pedido);
      const novoPedido = Object.assign({}, pedido, { exibirDetalhe: !pedido.exibirDetalhe });
      const pedidos = Object.assign([], state.pedidos);
      pedidos[indice] = novoPedido;
      return {
        ...state,
        pedidos
      }
    }

    default: {
      return state
    }
  }
}
